// extracted by mini-css-extract-plugin
module.exports = {"dragAndDrop":"drag_and_drop_dragAndDrop__36uZF","dragging":"drag_and_drop_dragging__2JXPf"};